export enum LearnHandle {
  invest = 'ecf_investor',
  raise = 'ecf_issuer',
  trade = 'pstx_investor',
  list = 'pstx_issuer',
  'token-invest' = 'ieo_investor',
  'token-issue' = 'ieo_issuer',
}
